import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';


import { DomSanitizer, SafeResourceUrl } from "@angular/platform-browser";
import { IAccessToken } from '../auth/auth.model';
import { AuthService } from '../auth/auth.service';
import { ExceptionManager } from '../common/exceptions';
import * as Globals from "../common/globals";
import { ProductLabelingState } from '../version-details/product.labeling.state';
import { IVersionDetails } from '../version-details/version.details.model';
import { VersionDetailsService } from '../version-details/version.details.service';



@Component({
    templateUrl: './login.html',
    styleUrls: ['./login.scss']
})

export class LoginComponent implements OnInit {

    public webLoginURL: SafeResourceUrl;

    public isUnreleasedDevice: boolean = false;
    public isNonMedicalDevice: boolean = true;
    public showAbout: boolean = false;
    public releaseVersion: string;
    public commercialVersion: string;
    public headerTitle: string  = "Workflow Information Management ";
    public headerTitleSecondary: string = "Enterprise Manager"
    public get copyrightMessage(): string {
        return  '© 2025 Koninklijke Philips N.V. All rights are reserved. Reproduction or transmission in whole or in part, in any form or by any means, electronic, mechanical or otherwise, is prohibited without the prior written consent of the copyright owner.';
    }

    public resources = {
        imgs: {
            philips: "./assets/images/philips.png",
            main: "./assets/images/EMLoginImage.png",
            consultSymbol: "./assets/images/consult.png",
            cautionSymbol: "./assets/images/caution.png",
        }
    };

    constructor(private router: Router,
                private auth: AuthService,
                private sanitizer: DomSanitizer,
                private versionDetailsService: VersionDetailsService) {
    }

    ngOnInit() {
        this.versionDetailsService.getVersionDetails().subscribe(
            versionDetails => {
                this.commercialVersion = versionDetails.commercialVersion;
                this.releaseVersion = this.getProductReleaseVersion(versionDetails.commercialVersion);

                this.setProductLabelingStateFields(versionDetails);
            }
            , err => {
                alert(new ExceptionManager().getHttpResponseMessage(err));
            })

        if (window.location.host === 'localhost:8282') {
            this.webLoginURL = this.sanitizer.bypassSecurityTrustResourceUrl('http://localhost:8082/assets/login?embeddedLogin=true');
        } else {
            this.webLoginURL = this.sanitizer.bypassSecurityTrustResourceUrl(window.location.origin + '/web?embeddedLogin=true');
        }

        if (window.addEventListener) {
            window.addEventListener('message', this.receiveMessageFromExternalLogin.bind(this), false);
        } else {
            (<any>window).attachEvent('onmessage', this.receiveMessageFromExternalLogin.bind(this));
        }

    }

    private doLogin(data : IAccessToken) {
        this.auth.login(data).subscribe(
            data => {
                // login successful so redirect to return url
                this.navigateToSuccessURL();
            });
    }

    private receiveMessageFromExternalLogin(evt: MessageEvent) {
        if (evt.origin === 'http://localhost:8082' || (<Window>evt.source)?.location?.pathname === '/Web/login')  {
            this.doLogin(evt.data);
        }
    }

    private navigateToSuccessURL() {
      if(this.auth.isPermmitted(Globals.componentsPermissions["RisMonitoringScriptsResultsComponent"])) {
        this.router.navigateByUrl('/shell/ris-monitoring-scripts-results');
      } else {
        this.router.navigateByUrl('/shell/ris-servers-state');
      }
    }

    
    private setProductLabelingStateFields(versionDetails: IVersionDetails){
        this.setHeaderTitle(versionDetails);
        this.isUnreleasedDevice = (versionDetails.productLabelingState === ProductLabelingState.UnreleasedDevice);
        this.isNonMedicalDevice = (versionDetails.productLabelingState !== ProductLabelingState.ReleasedMedicalDevice);
    }

    private setHeaderTitle(versionDetails: IVersionDetails) {
        let titleText = this.headerTitle;
        titleText += versionDetails.commercialVersion.split('.')[0];
        this.headerTitle = titleText;
        this.headerTitleSecondary = "Enterprise Manager";
        if (versionDetails.productLabelingState === ProductLabelingState.UnreleasedDevice) {
            this.headerTitleSecondary += " (WIP)";
        }
    }

    private getProductReleaseVersion(commercialVersion: string): string {
        const versionParts : string[] = commercialVersion.split('.');
        if (versionParts.length > 1){
            return `${versionParts[0]}.${versionParts[1]}`;
        }
        return commercialVersion;
    }
}
